import { v4 as uuidv4 } from 'uuid';
import { images } from '../../constants';

const spaceHubData = {
  id: uuidv4(),
  title: 'Space Hub Shuttle',
  category: 'Frontend',
  description: 'An app that allows users to rent their favorite rockets and reserve their space missions.',
  image: images.space,
  liveLink: 'https://space-hub-shuttle.netlify.app/',
  codeLink: 'https://github.com/Carshy/space-traveller-app',
  tags: {
    react: 'React JS & Redux',
    rest: 'RESTful API',
    sass: 'SCSS',
  },
};

const revDesk = {
  id: uuidv4(),
  title: 'Rev Desk',
  category: 'Frontend',
  description: 'RevDesk is a frontend dashboard for managing sales leads, customer support tickets, and HubSpot-connected workflows using HTML, Tailwind CSS, and JavaScript.',
  image: images.rev,
  liveLink: 'https://revdesk.netlify.app/',
  codeLink: 'https://github.com/Carshy/ClientFlow-CMS',
  tags: {
    js: 'JavaScript',
    rest: 'Hubspot API',
    sass: 'Tailwind CSS',
  },
};

const salesPoint = {
  id: uuidv4(),
  title: 'Social Marketplace',
  category: 'Full-Stack',
  description: 'A hybrid social marketplace for collectible items where users can discover listings, negotiate through direct item-level messaging and offers, complete checkout, and confirm sales, built with EJS, Lit, Tailwind CSS, and Express.',
  image: images.sales,
  liveLink: 'https://social-marketplace-web.onrender.com/',
  codeLink: 'https://github.com/Carshy/social-marketplace',
  tags: {
    express: 'Express',
    lit: 'Lit',
    sass: 'Tailwind CSS',
  },
};

const storeFront = {
  id: uuidv4(),
  title: 'Store Front',
  category: 'Frontend',
  description: 'Store Front is a modern e-commerce platform designed for speed, security, and seamless user experience. It offers a rich product catalog, smart filtering, secure cart functionality, and a fully responsive design across all devices.',
  image: images.store,
  liveLink: 'https://luxelined.netlify.app/',
  codeLink: 'https://github.com/Carshy/storefront-coupon',
  tags: {
    react: 'React JS',
    rest: 'RESTful API',
    sass: 'Tailwind CSS',
  },
};

const paradiseData = {
  id: uuidv4(),
  title: 'Paradise Cuisine',
  category: 'Frontend',
  description: 'Paradise Cuisine is an innovative app that enables users to discover, cook, and savor special meals, breakfasts, and dinners from different cultures around the world.',
  image: images.paradise,
  liveLink: 'https://paradise-cuisine.netlify.app/',
  codeLink: 'https://github.com/Carshy/paradise-cuisine',
  tags: {
    react: 'React JS & Redux',
    js: 'JavaScript',
    rest: 'RESTful API',
    sass: 'SCSS',
  },
};

const talantaData = {
  id: uuidv4(),
  title: 'Talanta Fountain',
  category: 'Frontend',
  description: 'Talanta Fountain is a fully responsive web application that I created to showcase the nurturing of youth talents from vulnerable areas in African countries.',
  image: images.talantaF,
  liveLink: 'https://talanta-fountain.netlify.app/',
  codeLink: 'https://github.com/Carshy/Talanta-Fountain',
  tags: {
    js: 'JavaScript',
    dom: 'DOM',
    sass: 'SCSS',
  },
};

const portData = {
  id: uuidv4(),
  title: 'Portfolio App',
  category: 'Full-Stack',
  description: 'A full-stack app that allows employers to navigate through, and see my skills, experiences, and attributes.',
  image: images.portfolio,
  liveLink: 'https://collins-musoko-portfolio.netlify.app/',
  codeLink: 'https://github.com/Carshy/portfolio-app',
  tags: {
    react: 'React JS & Redux',
    sanity: 'Sanity.io',
    sass: 'SCSS',
  },
};

const allProjectsData = [salesPoint, storeFront,
  revDesk, paradiseData, spaceHubData, talantaData, portData];

export default allProjectsData;
